import React from 'react';

function JcbIcon() {
  return (
    <svg width="58" height="40" viewBox="0 0 58 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.9419 20.5254C38.9357 20.547 39.9351 20.4815 40.925 20.5594C41.9274 20.7464 42.169 22.264 41.2784 22.761C40.6708 23.0884 39.9489 22.8829 39.2902 22.9407H37.9419V20.5254V20.5254ZM41.4996 17.7916C41.7204 18.571 40.9691 19.2707 40.2185 19.1634H37.9419C37.9578 18.4284 37.9106 17.6307 37.965 16.9344C38.877 16.9601 39.7975 16.882 40.7042 16.9752C41.0938 17.0731 41.4199 17.3934 41.4996 17.7916V17.7916ZM46.9787 6.23394C47.021 7.72232 46.9848 9.28936 46.9969 10.8079C46.9941 16.9819 47.0029 23.1557 46.9921 29.3299C46.9521 31.6438 44.9015 33.6543 42.6037 33.7005C40.3036 33.7099 38.0033 33.702 35.7029 33.7045V24.3708C38.2092 24.3579 40.7169 24.3971 43.2222 24.3512C44.3844 24.2783 45.6575 23.5114 45.7116 22.2324C45.8484 20.9479 44.6374 20.0594 43.4876 19.9191C43.0456 19.9076 43.0585 19.7902 43.4876 19.739C44.5842 19.502 45.4454 18.367 45.1227 17.2303C44.8478 16.0347 43.5263 15.572 42.4272 15.5743C40.1861 15.5591 37.9446 15.5722 35.7034 15.5677C35.7178 13.8253 35.6732 12.0809 35.7275 10.3397C35.905 8.0676 38.0073 6.19388 40.2728 6.23454C42.5083 6.2342 44.7436 6.2342 46.9787 6.23411V6.23394Z"
        fill="url(#paint0_linear_17173_1201)"
      />
      <path
        d="M10.377 10.5749C10.4342 8.26476 12.4936 6.2707 14.7885 6.23694C17.08 6.22988 19.3719 6.23592 21.6634 6.23388C21.6571 13.9632 21.6759 21.6934 21.654 29.4223C21.5657 31.7044 19.5288 33.6605 17.2589 33.7009C14.9631 33.7092 12.6669 33.7021 10.371 33.7044V24.056C12.6011 24.5828 14.9398 24.8071 17.2149 24.4576C18.5748 24.2388 20.0628 23.571 20.5232 22.1601C20.8621 20.9532 20.6713 19.683 20.7217 18.4443V15.5677H16.7844C16.7667 17.4702 16.8206 19.3761 16.7559 21.2763C16.6498 22.4444 15.4931 23.1865 14.3915 23.1468C13.0253 23.1613 10.3181 22.1567 10.3181 22.1567C10.3113 18.5921 10.3577 14.128 10.377 10.5753V10.5749Z"
        fill="url(#paint1_linear_17173_1201)"
      />
      <path
        d="M23.1316 16.7284C22.9243 16.7724 23.0899 16.0225 23.0369 15.738C23.0511 13.9393 23.0074 12.1386 23.061 10.3412C23.2381 8.0595 25.3564 6.1811 27.6311 6.23451H34.3299C34.3236 13.9639 34.3423 21.694 34.3205 29.423C34.2321 31.7051 32.1951 33.661 29.9251 33.7015C27.6292 33.7102 25.333 33.7029 23.0369 33.7051V23.1339C24.605 24.4206 26.7363 24.6209 28.6899 24.6244C30.1627 24.6239 31.627 24.3968 33.0572 24.0571V22.1205C31.4454 22.9238 29.5506 23.4341 27.7638 22.9725C26.5174 22.6623 25.6126 21.4577 25.6328 20.1714C25.4884 18.8337 26.2725 17.4215 27.587 17.0238C29.2191 16.5128 30.9979 16.9036 32.5278 17.5679C32.8555 17.7395 33.1882 17.9524 33.0572 17.4045V15.8823C30.4985 15.2735 27.7755 15.0495 25.205 15.7118C24.4609 15.9217 23.736 16.24 23.1316 16.7286V16.7284Z"
        fill="url(#paint2_linear_17173_1201)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_17173_1201"
          x1="35.6258"
          y1="19.3819"
          x2="46.9257"
          y2="19.3819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B03A" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_17173_1201"
          x1="10.1307"
          y1="20.2322"
          x2="21.4783"
          y2="20.2322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6EB6" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_17173_1201"
          x1="23.0203"
          y1="19.6486"
          x2="34.3278"
          y2="19.6486"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE0D3D" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default JcbIcon;
